// assets
import { NavItemType } from 'types';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import GroupOutlined from '@mui/icons-material/GroupOutlined';
import { IconRobotFace, IconTemplate, IconSend, IconShoppingCart } from '@tabler/icons-react';
import LabelOutlined from '@mui/icons-material/LabelOutlined';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import HistoryEduOutlinedIcon from '@mui/icons-material/HistoryEduOutlined';
import MapIcon from '@mui/icons-material/Map';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined';

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages: NavItemType = {
  id: 'pages',
  title: 'pages',
  caption: 'pages-caption',
  type: 'group',
  children: [
    // Section 0 — בסיסי (עמודה ימנית ב־RTL)
    {
      id: 'section-basic',
      type: 'group',
      title: 'header.megamenu.sections.basic',
      children: [
        {
          id: 'contacts',
          url: '/contacts/chat',
          title: 'header.megamenu.contacts.title',
          caption: 'header.megamenu.contacts.caption',
          icon: <ContactsOutlinedIcon />,
          type: 'item',
          breadcrumbs: false,
        },
        {
          id: 'app-users',
          url: '/users',
          title: 'header.megamenu.app-users.title',
          caption: 'header.megamenu.app-users.caption',
          icon: <GroupOutlined />,
          type: 'item',
        },
        {
          id: 'chats',
          url: '/company/conversation',
          title: 'header.megamenu.chats.title',
          caption: 'header.megamenu.chats.caption',
          icon: <ForumOutlinedIcon />,
          type: 'item',
          breadcrumbs: false,
        },
        {
          id: 'telephony',
          url: '/telephony/phone-calls',
          title: 'header.megamenu.telephony.title',
          caption: 'header.megamenu.telephony.caption',
          icon: <PhoneInTalkOutlinedIcon />,
          type: 'item',
          breadcrumbs: false,
        },
        {
          id: 'gisMaps',
          url: '/map-insights',
          title: 'header.megamenu.gisMaps.title',
          caption: 'header.megamenu.gisMaps.caption',
          icon: <MapIcon />,
          type: 'item',
          breadcrumbs: false,
        },
      ],
    },
    // Section 1 - שימוש מתקדם
    {
      id: 'section-1',
      type: 'group',
      title: 'settingsPopup.navigation.constantUse.label',
      customPage: true,
      children: [
        {
          id: 'calendar',
          url: '/calendar',
          title: 'header.megamenu.calendar.title',
          caption: 'header.megamenu.calendar.caption',
          icon: <EventOutlinedIcon />,
          type: 'item',
          breadcrumbs: false,
        },
        {
          id: 'broadcasts',
          url: '/broadcasts',
          title: 'header.megamenu.broadcasts.title',
          caption: 'header.megamenu.broadcasts.caption',
          icon: <IconSend />,
          type: 'item',
          breadcrumbs: false,
        },
        {
          id: 'workflows',
          url: '/workflows',
          title: 'header.megamenu.workflows.title',
          caption: 'header.megamenu.workflows.caption',
          icon: <IconRobotFace />,
          type: 'item',
        },
        {
          id: 'orders-agent',
          url: '/orders-agent',
          title: 'header.megamenu.ordersAgent.title',
          caption: 'header.megamenu.ordersAgent.caption',
          icon: <IconShoppingCart />,
          type: 'item',
        },
        {
          id: 'flowise',
          url: '/flowise',
          title: 'header.megamenu.flowise.title',
          caption: 'header.megamenu.flowise.caption',
          icon: <HubOutlinedIcon />,
          type: 'item',
        },
        {
          id: 'signer',
          url: '/signer',
          title: 'header.megamenu.signer.title',
          caption: 'header.megamenu.signer.caption',
          icon: <HistoryEduOutlinedIcon />,
          type: 'item',
        },
      ],
    },
    // Section 2 - ניהול המערכת
    {
      id: 'section-2',
      type: 'group',
      title: 'settingsPopup.navigation.systemManagement.label',
      customPage: true,
      children: [
        {
          id: 'templates',
          url: '/templates',
          title: 'header.megamenu.templates.title',
          caption: 'header.megamenu.templates.caption',
          icon: <IconTemplate />,
          type: 'item',
          breadcrumbs: false,
        },
        {
          id: 'labels',
          url: '/labels',
          title: 'header.megamenu.labels.title',
          caption: 'header.megamenu.labels.caption',
          icon: <LabelOutlined />,
          type: 'item',
        },
        {
          id: 'drive',
          url: '/drive/images',
          title: 'header.megamenu.files.title',
          caption: 'header.megamenu.files.caption',
          icon: <FolderOpenOutlinedIcon />,
          type: 'item',
          breadcrumbs: false,
        },
        {
          id: 'AISupport',
          url: '/ai-support',
          title: 'header.megamenu.ai.title',
          caption: 'header.megamenu.ai.caption',
          icon: <AutoAwesomeOutlinedIcon />,
          type: 'item',
        },
        {
          id: 'boards',
          url: '/boards',
          title: 'header.megamenu.boards.title',
          caption: 'header.megamenu.boards.caption',
          icon: <AssessmentOutlinedIcon />,
          type: 'item',
        },
      ],
    },
  ],
};

export { pages };
export default pages;
